import React from 'react';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function GeneralRiskTypesTableRow(props) {
    return (
        <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
            <td onClick={props.onEdit}>{props.type.title}</td>
            <td dangerouslySetInnerHTML={{ __html: props.type.description }} onClick={props.onEdit} />
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3.5">
                    <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue" onClick={props.onEdit}>
                        <EditIcon className="tw-h-3" />
                        <div>{$t('Edit')}</div>
                    </button>
                    <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-red" onClick={props.onDelete}>
                        <TrashIcon className="tw-h-3" />
                        <div>{$t('Delete')}</div>
                    </button>
                </div>
            </td>
        </tr>
    );
}
